(() => {
  const configElement = document.getElementById('FermenteriaTemperatureConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = document.documentElement;
  const originalButtons = new WeakMap();
  const allowedForms = new WeakSet();
  let mixed = config.mixed;
  let checking = false;
  let failed = false;
  let revision = 0;
  let requestChain = Promise.resolve();
  let proceeding = false;
  let renderScheduled = false;

  function render() {
    root.dataset.fermenteriaTemperatureMixed = String(mixed);
    root.dataset.fermenteriaTemperaturePending = String(checking || failed);
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      if (!('disabled' in button)) return;
      if (!originalButtons.has(button)) {
        originalButtons.set(button, {
          disabled: button.hasAttribute('data-fermenteria-temperature-disabled') ? false : button.disabled,
          aria: button.getAttribute('aria-disabled'),
        });
      }
      const original = originalButtons.get(button);
      if (mixed || checking || failed) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-fermenteria-temperature-disabled', '');
      } else {
        button.disabled = original.disabled;
        if (original.aria === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', original.aria);
        button.removeAttribute('data-fermenteria-temperature-disabled');
      }
    });
    document.querySelectorAll('[data-fermenteria-temperature-notice]').forEach((notice) => {
      notice.hidden = !(mixed || failed);
      notice.querySelector('[data-fermenteria-temperature-copy]').hidden = !mixed;
      notice.querySelector('[data-fermenteria-temperature-error]').hidden = !failed;
    });
  }

  function refresh() {
    const current = ++revision;
    checking = true;
    render();
    requestChain = requestChain.catch(() => {}).then(async () => {
      const url = new URL(config.cartUrl, window.location.origin);
      url.searchParams.set('section_id', 'fermenteria-temperature-state');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart check unavailable');
      const documentState = new DOMParser().parseFromString(await response.text(), 'text/html');
      const value = documentState.querySelector('[data-fermenteria-temperature-state]')?.dataset.fermenteriaTemperatureState?.trim();
      if (value !== 'true' && value !== 'false') throw new Error('Cart check unavailable');
      if (current === revision) {
        mixed = value === 'true';
        failed = false;
      }
    }).catch(() => {
      if (current === revision) failed = true;
    }).finally(() => {
      if (current === revision) {
        checking = false;
        render();
      }
    });
    return requestChain;
  }

  function focusNotice() {
    const notice = [...document.querySelectorAll('[data-fermenteria-temperature-notice]')]
      .find((element) => !element.hidden && element.getClientRects().length);
    if (notice) {
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      notice.focus({ preventScroll: true });
    }
  }

  async function proceed(form, submitter, href) {
    if (proceeding) return;
    proceeding = true;
    await refresh();
    if (mixed || failed) {
      proceeding = false;
      focusNotice();
      return;
    }
    const tasks = [];
    document.dispatchEvent(new CustomEvent('fermenteria:before-checkout', { detail: { tasks } }));
    try {
      const results = await Promise.all(tasks);
      if (results.some(result => result === false)) {
        proceeding = false;
        return;
      }
    } catch {
      proceeding = false;
      return;
    }
    proceeding = false;
    if (href) {
      window.location.assign(href);
    } else if (form) {
      allowedForms.add(form);
      form.requestSubmit(submitter);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="checkout"]');
    if (button?.form) {
      event.preventDefault();
      event.stopImmediatePropagation();
      proceed(button.form, button);
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin === window.location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      proceed(null, null, url.href);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (allowedForms.has(event.target)) {
      allowedForms.delete(event.target);
      return;
    }
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    proceed(event.target, event.submitter);
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('shopify:section:load', render);
  new MutationObserver(() => {
    if (renderScheduled) return;
    renderScheduled = true;
    requestAnimationFrame(() => {
      renderScheduled = false;
      render();
    });
  }).observe(document.body, { childList: true, subtree: true });
  render();
})();

